import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom'
import Sidebar from '@/components/layout/Sidebar'
import ToastContainer from '@/components/layout/Toast'
import AuthGuard from '@/components/auth/AuthGuard'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Clientes from '@/pages/Clientes'
import Servicios from '@/pages/Servicios'
import Perfiles from '@/pages/Perfiles'
import Configuracion from '@/pages/Configuracion'
import Cotizaciones from '@/pages/Cotizaciones'
import NuevaCotizacion from '@/pages/NuevaCotizacion'
import VerCotizacion from '@/pages/VerCotizacion'
import NuevaCotEquipo from '@/pages/NuevaCotEquipo'
import PortalCliente from '@/pages/PortalCliente'

function AppLayout() {
  return (
    <div className="app" id="app">
      <Sidebar />
      <main className="main-content" id="main-content">
        <Outlet />
      </main>
      <ToastContainer />
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public — no auth required */}
        <Route path="/login" element={<Login />} />
        <Route path="/ver/:token" element={<PortalCliente />} />

        {/* Protected — requires authenticated session */}
        <Route element={<AuthGuard />}>
          <Route element={<AppLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="servicios" element={<Servicios />} />
            <Route path="perfiles" element={<Perfiles />} />
            <Route path="configuracion" element={<Configuracion />} />
            <Route path="cotizaciones" element={<Cotizaciones />} />
            <Route path="cotizaciones/nueva" element={<NuevaCotizacion />} />
            <Route path="cotizaciones/:id" element={<VerCotizacion />} />
            <Route path="cotizaciones/:id/editar" element={<NuevaCotizacion />} />
            <Route path="equipo/nueva" element={<NuevaCotEquipo />} />
            <Route path="equipo/:id" element={<VerCotizacion />} />
            <Route path="equipo/:id/editar" element={<NuevaCotEquipo />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
